export const outlineStyle = () =>
  'box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.3);';

export const linkStyle = () => `
  color: #06f;
  font: inherit;
  line-height: 1.15;
  border-bottom: 0.1em solid transparent;
  cursor: pointer;
  outline: none;
  :focus {
    text-decoration: inherit;
    ${outlineStyle()}
  }
  :hover {
    border-color: currentColor;
  }
`;

export const ellipsisStyle = () => `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ELLIPSIS_PROPS = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
